import CSS from 'csstype';
import { IDashboardDoughnut, IStat } from '../generated/graphql';
import { Colors, DashboardColors } from './theme';
import moment from 'moment-timezone';
import { DATE_TIME_FORMATS } from '../enums/AppConsts';

type colorOptions = {
  [key: string]: {
    color: string;
  };
};

const tabStyle = {
  common: {
    color: Colors.skyBlue + 'CC !important',
    fontSize: '22px',
    textTransform: 'none'
  },
  default_tab: {
    backgroundColor: '#E4F1FF',
    borderBottom: '0.8px solid' + Colors.third
  },
  active_tab: {
    backgroundColor: 'white',
    fontWeight: 'bold'
  },
  leftBorder: {
    borderLeft: '2px solid' + Colors.third
  }
};

const membershipColorOptions: colorOptions = {
  FULL: { color: Colors.green },
  ASSOC: { color: Colors.warning },
  TRIAL: { color: Colors.main },
  ACAD: { color: Colors.gray },
  'BPR FULL': { color: Colors.purple }
};

const mailColorOptions: colorOptions = {
  sent: { color: DashboardColors.light_blue },
  delivered: { color: Colors.main },
  read: { color: Colors.green },
  blocks: { color: DashboardColors.dark_yellow },
  bounces: { color: Colors.purple },
  spam_reports: { color: Colors.red }
};

const outerTabStyle = {
  common: {
    textTransform: 'none',
    fontSize: '20px',
    borderBottom: '1px solid ' + Colors.main
  },
  default_tab: {
    color: Colors.main + '99'
  },
  active_tab: {
    color: Colors.main
  }
};

const infoWrapperTabStyle = {
  common: {
    height: '60px'
  },
  default_tab: {
    color: Colors.white + '99'
  },
  active_tab: {
    color: Colors.white
  }
};
export const getTabStyle = (index: number, tabValue: number): CSS.Properties => {
  let result =
    index === tabValue
      ? { ...tabStyle.common, ...tabStyle.active_tab }
      : { ...tabStyle.common, ...tabStyle.default_tab };
  if (index > 0) {
    result = { ...result, ...tabStyle.leftBorder };
  }

  return result as CSS.Properties;
};

export const getOuterStyle = (index: number, tabValue: number): CSS.Properties => {
  const result =
    index === tabValue
      ? { ...outerTabStyle.common, ...outerTabStyle.active_tab }
      : { ...outerTabStyle.common, ...outerTabStyle.default_tab };
  return result as CSS.Properties;
};

export const getInfoWrapperTabStyle = (index: number, tabValue: number): CSS.Properties => {
  const result =
    index === tabValue
      ? { ...infoWrapperTabStyle.common, ...infoWrapperTabStyle.active_tab }
      : { ...infoWrapperTabStyle.common, ...infoWrapperTabStyle.default_tab };
  return result as CSS.Properties;
};

export const getRequiredFieldLabelColor = (isEditMode: boolean, prop: string | null): string => {
  return isEditMode ? (prop !== null ? 'red' : Colors.main) : Colors.gray;
};

export const getLabelColor = (isEditMode: boolean): string => {
  return isEditMode ? Colors.main : Colors.gray;
};

export const getInputTextColor = (isEditMode: boolean): string => {
  return getLabelColor(isEditMode);
};

export const getMembershipColors = (input: IDashboardDoughnut[]): string[] => {
  const result = input.map((i) => membershipColorOptions[i.membership_type]?.color);
  return result;
};

export const getMassMailColors = (input: IStat[]): string[] => {
  if (input.length > 0) {
    const props = Object.keys(input[0]);
    const colors = props.map((p) => mailColorOptions[p]?.color);
    const result = colors.filter((c) => c !== undefined);
    return result;
  }
  const props = Object.keys(mailColorOptions);
  return props.map((p) => mailColorOptions[p].color);
};

export const DATE_FORMAT = 'dd.MM.yyyy';

export const renderDateString = (input: string) => {
  const date = new Date(input).getTime().toString();
  return renderDate(date, DATE_TIME_FORMATS.DATE);
};

export const renderDate = (input: string, format?: string) => {
  return moment(parseInt(input)).format(format ?? 'DD-MM-yy');
};

export const iconStyle: CSS.Properties = {
  verticalAlign: 'middle',
  marginBottom: '4px',
  marginRight: '2px'
};

export const renderNullableDate = (input: string | undefined | null, format: string) => {
  if (input) {
    return renderDate(input, format);
  } else {
    return null;
  }
};

export const FormatTableData = (data: any[] | undefined) => {
  return data ? data.map((m) => ({ ...m })) : [];
};
